const apiDomain = Laravel.apiDomain;
export const siteName = Laravel.siteName;

export const api = {
	domain: apiDomain + '/',
	login: apiDomain + '/auth/login',
	currentUser: apiDomain + '/auth/user',
	remember: apiDomain + '/auth/password/email',
	reset: apiDomain + '/auth/password/reset',
};